import { render, staticRenderFns } from "./OpeningSection.vue?vue&type=template&id=2324eaee"
import script from "./OpeningSection.vue?vue&type=script&lang=ts"
export * from "./OpeningSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports